var _defs, _g, _g2, _path, _g3, _g4, _path2, _path3, _path4, _path5, _path6, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClairaAdvAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 460 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: none;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #001997;\r\n      }\r\n\r\n      .st2 {\r\n        fill: #483932;\r\n      }\r\n\r\n      .st3 {\r\n        fill: #eff0f1;\r\n      }\r\n\r\n      .st4 {\r\n        fill: #3a2c2b;\r\n      }\r\n\r\n      .st5 {\r\n        fill: #f4b083;\r\n      }\r\n\r\n      .st6 {\r\n        fill: url(#radial-gradient);\r\n      }\r\n\r\n      .st7 {\r\n        fill: #322421;\r\n      }\r\n\r\n      .st8 {\r\n        fill: #251613;\r\n      }\r\n\r\n      .st9 {\r\n        fill: #fcfdf8;\r\n      }\r\n\r\n      .st10 {\r\n        fill: #38251e;\r\n      }\r\n\r\n      .st11 {\r\n        clip-path: url(#clippath-1);\r\n      }\r\n\r\n      .st12 {\r\n        clip-path: url(#clippath-2);\r\n      }\r\n\r\n      .st13 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st14 {\r\n        fill: #1d160e;\r\n      }\r\n\r\n      .st15 {\r\n        fill: #fffffd;\r\n      }\r\n\r\n      .st16 {\r\n        fill: #713e1f;\r\n      }\r\n\r\n      .st17 {\r\n        fill: #fefefe;\r\n      }\r\n\r\n      .st18 {\r\n        fill: url(#radial-gradient1);\r\n      }\r\n\r\n      .st19 {\r\n        fill: #e77a59;\r\n      }\r\n\r\n      .st20 {\r\n        isolation: isolate;\r\n        opacity: .8;\r\n      }\r\n\r\n      .st20, .st21 {\r\n        fill: #0b9ce9;\r\n      }\r\n\r\n      .st22 {\r\n        fill: #0e2faa;\r\n      }\r\n\r\n      .st23 {\r\n        fill: #dfdedc;\r\n      }\r\n\r\n      .st24 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .st25 {\r\n        fill: #e6916a;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 230.1,
    cy: 230.5,
    r: 180
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 281.5,
    cy: 258.1,
    fx: 281.5,
    fy: 258.1,
    r: 23,
    gradientTransform: "translate(103.2 -93) rotate(97.9) scale(1 -.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e9957b",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4b083",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.7,128.1c-25-4.9-48.6,7.6-48.6,7.6l-13,24.2s-1.7,8.4-2.8,16.5c5.9,7.9,9.9,17.1,11.3,26.9.8,5.6-.3,11-2.7,15.8,6.1,8.6,17.8,20,39.5,26.8,4.6,1.4,10.3-.8,16.3-7.1,6-6.2,13.6-14.4,16.8-19.5,3.3-5.2,7.3-13.3,6.8-20.4-.5-7.1-1.4-19,.3-26.9,1.6-7.9,1.1-39.1-23.9-44h0Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 195.2,
    cy: 1983.4,
    fx: 195.2,
    fy: 1983.4,
    r: 23,
    gradientTransform: "translate(583 -782.9) rotate(-172.1) scale(1 -.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e9957b",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4b083",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 281.3,
    y: 171.4,
    width: 95.8,
    height: 95.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 230.1,
    cy: 230.5,
    r: 180
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 230.1,
    cy: 230.5,
    r: 180
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M248.6,278s26.6,6.1,32.3,12.3,7.2,26.1,6.1,52.7l-38.4-65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M138.4,198.6c.4,10.2,14.4,17.3,19.1,19.4.9.4,1.6,1.2,1.9,2.2,1.2,3.8,5,13.6,12.6,17.8,9.5,5.3,16.3,2,16.3,2v-8.8c-7.8-3.5-15.2-26.7-15.2-26.7l-15.4-16.7s-5.8-9.8-1.8-9.5c3,.2,6.2,5.9,7.7,9,.3.5,1.1.4,1.2-.2l1.7-10.9c-4.4-2.4-8.6-5.2-12.4-8.4-9,14.1-15.9,26.5-15.7,30.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M180.2,282.3l37.1,74.5,13,37.5,1.2,28.2h43.6l5.7-64.8-16.3-48.5-24.8-35.4s-16.7-15.5-25.7-18.3l-24.4,6.5-9.4,20.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M220.5,257.1c-2.4-7.1-3.5-12.2-1.7-16l-32.3-13.7s1.9,7.6,1.6,16.5c.9,5.7,6.8,10.8,11.1,12.8,6.6,3,21.8,12.2,21.3.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M220.5,257.1c-.3,4.2-9.5,5.3-23.5-5.9-3.7-3-5.3-4.2-8.9-7.3-.2,5.3-1.1,11-3.7,15.8l51.5,60.8s-.3-17.9-6.9-38.8c-3.1-10-6.4-18.1-8.6-24.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.5,244.5c0,.3-1,.2-2.5-.4-1.4-.6-3.4-1.9-5.3-4.1-1.9-2.1-3.7-5.1-4.7-8.8-1.1-3.6-1.4-7.8-1.1-12s1.2-8.1,2.1-11.5,1.8-6.3,2.2-8.8c.4-2.5.5-4.5.4-5.9,0-1.4,0-2.3.2-2.4.3-.1.9.5,1.5,2s1.1,3.8,1.1,6.6-.6,6.1-1.3,9.5c-.7,3.4-1.4,7.1-1.7,10.9-.3,3.8,0,7.5.6,10.6s2,5.8,3.3,7.9c2.6,4.2,5.6,5.8,5.2,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M227.6,109.5s8.1-1.2,17.1,7.3,15,17,16.3,19.8c2.2,4.6,5,13.8,3.3,20-.1.5-.2,1.1,0,1.6.6,2.4,1.9,9.3-1,14.5-2.9,5.2-7.8,9.5-5.8,14.3s17.3,24.6-.5,33.9c6.1-5.8,5.8-14.2,4.3-18.3-2.3-6.4-10-6.5-9.3-16.1.8-9.5,9.5-45.1-23.3-58.7l-13.3-11,12.3-7.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.7,153.7c-.4,0-.4-1.8-1-4.4-.1-.7-.3-1.4-.5-2.2-.2-.8-.5-1.6-.8-2.4-.6-1.7-1.5-3.5-2.5-5.2-1.1-1.7-2.3-3.3-3.5-4.6-.6-.6-1.2-1.3-1.8-1.8-.6-.6-1.2-1-1.7-1.5-2.1-1.7-3.7-2.6-3.5-2.9,0-.3,1.9,0,4.4,1.6.6.4,1.3.8,2,1.3s1.4,1.1,2.1,1.8c1.4,1.4,2.8,3,3.9,4.9,1.2,1.9,2,3.9,2.6,5.7.3.9.5,1.8.6,2.7.2.8.2,1.6.3,2.4.2,2.9-.3,4.7-.6,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M229.7,128.1c-25-4.9-48.6,7.6-48.6,7.6l-13,24.2s-1.7,8.4-2.8,16.5c5.9,7.9,9.9,17.1,11.3,26.9.8,5.6-.3,11-2.7,15.8,6.1,8.6,17.8,20,39.5,26.8,4.6,1.4,10.3-.8,16.3-7.1,6-6.2,13.6-14.4,16.8-19.5,3.3-5.2,7.3-13.3,6.8-20.4-.5-7.1-1.4-19,.3-26.9,1.6-7.9,1.1-39.1-23.9-44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M226.8,113.4c-5.3-2.2-11,3.9-11,3.9l-22.8-6.3s-22.8,31.1-39,56.6c3.9,3.2,8,6,12.4,8.4l.8-4.9s19.6-19.5,23.1-25.1c3.5-5.5,16.8-17.4,29.4-16,9.1,1,10.2-3.5,10.2-3.5,0,0,2.2-11-3.1-13.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M176.6,203.3c-1.3-9.8-5.4-19-11.3-26.9-.6,4.6-1.1,9.1-1,12,0,0-3-10.3-7.6-10.3s-10,10-7.1,18.7,13.6,15.2,18.2,10.6c0,0,1.4,5,6.1,11.7,2.3-4.8,3.4-10.2,2.7-15.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M157.2,178.9c2.6,1.9,5.2,6.5,6.5,9.2.3.6,1.2.5,1.3-.2l2.8-17.9.7-.7c-3,.2-5.7,1-8.1,3.2-1.9,1.7-2.8,4-3.3,6.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M254.3,421.8h-7.9c4.5-21.2,2.3-55.4,1.7-60.2-1.3-10.9-3.2-15.4-5.2-19s-28.1-40.7-28.1-40.7l-1.2,7.7c-26.9-11-31.4-47.6-31.4-47.6l3.6-7.2c.1-.2.4-.3.6,0,28.5,30.2,63.2,83.6,65.3,87.2,2,3.7,3.3,7,4.9,21.4.6,5.2,0,45.9-2.3,58.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M233.9,285.1s5.7,11.6,17.9,19.8c-.2-11.7-5.4-20.6-11.5-28s-12.1-14-12.1-14c0,0-3.8-3.1-7.7-5.8,0,0,4.9,12.4,8.2,23.8,2.5,8.4,7.4,28.5,7,38.3l2.4,4.2s1.4-16.6-4.3-38.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M223.5,259.3s32,47,39.3,58,13.5,27.2,14,39c.4,11.8-5.5,50.7-11.6,66.5h10.6s13.1-47.7,13.1-57.1-4.5-55.4-9.8-65.2l-20-4.5,12.6-1.6s-32.5-26.4-48.3-35.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.8,278.5s-35.8,13.8-47.1,28.2c0,0,11.8,2.6,20,17.4s7.7,33.3,4.6,41c0,0,15.4,14.8,16.4,56.8h67.3l-42.2-127-18.9-16.4h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M182.8,260.7s5,21.7,15,36.8,37.4,71.3,38.2,123.8h-9.4s-23.2-80.9-58.4-108.3l18.6-11.3-20.9,4.6s1.9-15.2,5.2-27.3c.3-1.1.8-2.2,1.4-3.2,2.2-3.6,7.3-12.1,10.3-15.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M125.8,305.6s-4.6-1.5-6.1,21c-1.6,24.1-20,68.6-29.7,96.8h43l21.4-63.7c.7-2,1-4.1.8-6.2-1-11-6.2-45.7-29.4-47.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M160.4,190.6s-2.5-5.6-5-5.2-5.1,9-1.4,11.4,6.2,4.7,4.8,5.2c2.2.6,5.7-.3,3.9-2.5-1.8-2.3-3.2-2.2-4.7-4.2s0-2.8,1.1-2.8,1.5-1.1,1.1-1.9h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M199,217.3c2.1.6,6.7.9,10,.7,3-.2,7-.6,10.4.6.7.2,1.4.2,2.1,0,3-1,4.9-.7,6.8-.5,2.2.2,4.8.4,6,.3-.9.9-2.6,4.1-3.1,5.2s-3.8,7.9-11.6,7.8-14.6-3.8-20.7-13.9v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M201.6,219.2c-.1-.1,0-.3.2-.2,2.4.8,12.2,3.9,19,3.3,5.7-.5,9.6-1.8,10.8-2.3s.2,0,.2.2c-.7,1.4-4.4,6-11.6,6.2-7.6.2-16.1-5-18.5-7.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.2,180.8s.7,16.9,26.4,10.7c-.3-4.9-5.3-15.2-14.4-15.5-9.1-.3-12,4.8-12,4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M230,192.8s19.2,7.3,21.6-9.6l-1.1-4.1-6.6-2.3-4.7,1s-8.3,3.8-9.2,15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.2,192.8s-.3.1-.8.2h-2.2c-1.9-.1-4.6-.7-7.1-2.2-2.6-1.5-4.3-3.7-5-5.5-.4-.9-.5-1.7-.5-2.3s.2-.8.2-.8c.2,0,0,1.2,1,2.8.8,1.6,2.5,3.5,4.9,4.9s4.9,2,6.7,2.3c.9.2,1.6.3,2.2.4.5,0,.8.2.8.3h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M251.6,182.6s.1.3.2.7c0,.5.1,1.2,0,2.1-.2,1.7-.9,4.3-3,6.1-2.1,1.9-4.5,2.5-6.2,2.8s-2.8.1-2.8,0c0-.2,1-.3,2.6-.8,1.6-.4,3.8-1.2,5.6-2.9,1.8-1.6,2.7-3.8,3-5.4.2-.8.3-1.5.3-1.9s.2-.7.2-.7h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 194.6,
    cy: 184,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 194.6,
    cy: 184,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M175.9,178.5s1.5,2.5,5.8,4.3c2.1-3.4,7.8-7.4,15.2-5.1,7.4,2.3,10.7,10.3,10.8,13.8-.2-4.2-2.3-12.5-9.8-15.8-7.5-3.4-13.9-.2-16.5,1.7-.7.6-3.9,1.8-5.6,1.1h.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 198,
    cy: 182.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M238.3,178c-3.1,2.2-5.4,5.2-7.2,8.6,0,.8-.3,1.6-.5,2.3,1.2,2.6,3.8,4.3,6.9,4.3s7.6-3.4,7.6-7.6-3-7.2-6.8-7.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 237.5,
    cy: 185.6,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 240.9,
    cy: 183.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M230.1,191.3s.4-14.2,14-15.8c2.2-.2,5.8,1,7.2,2.2s2.6,2.4,4.7,1.9c-.3,1-.6,3.1-4.6,3.6-.5-2.9-3.6-5.7-7.5-5.4s-8.9,1.2-13.8,13.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M182.7,179.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M226.1,202.7s2.7,2.6,2.9,4.4-2.1,4.8-5.8,5.1c-3.8.3-8.2-2.7-8.2-2.7,3.4,1,8.6.5,10.3-.7s1.7-3.4.9-6.2h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 185.5,
    cy: 203.5,
    rx: 9.6,
    ry: 19.6,
    transform: "translate(-79.6 277.8) rotate(-63.3)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 247.7,
    cy: 205.8,
    rx: 19.6,
    ry: 9.6,
    transform: "translate(-74.4 205.2) rotate(-39.6)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M229.5,164.8s0-5.7,6.2-7.3c6.2-1.6,10.3-2.7,12.5-1.9s5.7,3.8,7.3,7.6v4.1s-2.4-7.9-7.9-7.9-10.3,5.7-18.2,5.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M175.7,161.5s7.1-4.9,12.2-5.4c6.8-.7,16.6,1.1,19.5,3.8,0,0,1.3,2.2,1.8,4.8s-.3.8-.7.6c-3.1-1-13.8-4.2-21.7-4.9s-12.2,4.9-12.2,4.9l1.1-3.8h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 240.2,
    cy: 331.5,
    rx: 2.1,
    ry: 2.8,
    transform: "translate(-105.2 111.7) rotate(-21.6)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 250.7,
    cy: 352.3,
    rx: 2.1,
    ry: 2.8,
    transform: "translate(-49.3 40.9) rotate(-8.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 252.6,
    cy: 379.1,
    rx: 2.8,
    ry: 2.1,
    transform: "translate(-133.8 620.4) rotate(-88.3)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M203,349.6c-13.5,3.7-27.4,4.8-40.9,5.8-1.4-8.4-2.7-16.5-4-24.9,13.4-.7,27-2.8,40.5-6.2,1.4,8.2,3.1,17.1,4.5,25.3h-.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M169.8,347.2c-.9.1-1.7,0-2.4-.3-.7-.3-1.3-.8-1.7-1.4-.5-.6-.8-1.4-.9-2.3,0-.7,0-1.3,0-1.9s.3-1.1.6-1.5c.3-.4.7-.8,1.2-1,.5-.3,1.1-.4,1.7-.5h1.3c.5,0,.9.2,1.2.4.2,0,.3.2.4.3,0,.1.1.3.1.4s0,.3-.1.4c0,.1-.2.2-.3.2h-.5c-.3-.1-.6-.2-.9-.3h-.9c-.6,0-1,.2-1.4.5s-.6.7-.7,1.1c0,.5,0,1,0,1.7,0,.6.3,1.2.6,1.6.3.4.6.8,1.1.9.4.2.9.3,1.5.2.3,0,.6-.1.9-.2.3-.1.6-.3.8-.5.2-.1.3-.2.5-.2s.3,0,.4.1c.1,0,.2.2.3.3v.4c0,.1-.1.3-.2.4-.3.3-.6.5-1.1.7-.4.2-.9.3-1.3.4h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M175.7,346.4c-.7,0-1.2,0-1.6-.4-.4-.3-.7-.9-.8-1.6-.3-1.9-.6-3.9-1-5.8v-.6c.1-.1.3-.2.5-.3.2,0,.4,0,.6.1.2.1.3.3.3.5.3,1.9.6,3.8,1,5.7,0,.4.2.6.4.8.2.2.4.2.7.2h.6s.1.2.1.5v.5c0,.1-.2.2-.4.3h-.6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M179.3,345.8h-1.2c-.4-.1-.7-.3-.9-.6-.2-.3-.4-.6-.4-.9s0-.8.2-1.1c.2-.3.5-.5,1-.7s1.2-.4,2-.5c.2,0,.4,0,.6-.1,0,.3,0,.6.1.9-.2,0-.4,0-.6.1-.5,0-.9.2-1.2.3-.3,0-.5.2-.6.4-.1.1-.1.3-.1.5,0,.3.2.5.4.6s.5.2.8.1c.3,0,.5-.1.7-.3.2-.2.3-.4.4-.6,0-.2.1-.5,0-.8,0-.5-.2-.9-.2-1.4s-.2-.7-.4-.8c-.2-.1-.5-.2-.9-.1-.2,0-.5.1-.7.2-.3.1-.5.2-.8.4-.1,0-.3.1-.4.1s-.2,0-.3-.2c0,0-.1-.2-.2-.3v-.4c0-.1.1-.2.3-.3.3-.2.7-.4,1-.5s.6-.2.9-.2h1.5c.4.1.7.3,1,.7.3.3.4.8.5,1.3.2,1,.3,1.9.5,2.9v.6c0,.2-.3.3-.5.3s-.4,0-.6-.1c-.2-.1-.2-.3-.3-.5v-.6h0c0,.3,0,.6-.2.8-.1.2-.3.4-.5.6s-.5.3-.8.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M183.2,337.7h-.7c-.2-.1-.3-.3-.3-.5,0-.3,0-.5.1-.6.1-.2.3-.3.6-.3h.7c.2.1.3.3.3.6s0,.5-.1.6c-.1.2-.3.3-.6.3h0ZM184.4,344.9c-.2,0-.4,0-.6-.1-.2-.1-.3-.3-.3-.6-.3-1.5-.5-3-.8-4.5v-.7c.1-.2.3-.3.5-.3s.4,0,.6.1c.2.1.3.3.3.6.3,1.5.5,3,.8,4.5v.6c-.1.2-.3.3-.5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M187.3,344.3h-.6c-.2-.1-.3-.3-.3-.5-.3-1.5-.5-3.1-.8-4.6v-.6c.1-.2.3-.3.5-.3h.6c.2.1.2.3.3.5,0,.3,0,.5.1.8h-.1c0-.5.2-.9.5-1.2.3-.3.7-.6,1.3-.7h.4c.1,0,.2.2.3.4v.5c0,.1-.2.3-.5.3h-.3c-.5.2-.8.4-1,.7-.2.3-.3.7-.2,1.1.1.8.3,1.7.4,2.5v.6c-.1.2-.3.3-.5.3v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M192.9,343.1c-.4,0-.8.1-1.2,0-.4,0-.7-.3-.9-.5s-.4-.5-.4-.9,0-.8.2-1.1c.2-.3.5-.6,1-.8.5-.2,1.2-.4,2-.6.2,0,.4,0,.6-.1,0,.3,0,.6.1.9-.2,0-.4,0-.6.1-.5.1-.9.2-1.2.4-.3.1-.5.2-.6.4-.1.1-.1.3-.1.5,0,.3.2.5.4.6s.5.1.8,0c.3,0,.5-.2.7-.4.2-.2.3-.4.4-.6,0-.2.1-.5,0-.8,0-.5-.2-.9-.2-1.4s-.2-.7-.4-.8c-.2-.1-.5-.2-.9,0-.2,0-.5.1-.7.3-.3.1-.5.3-.8.5-.1.1-.3.2-.4.1-.1,0-.2,0-.3-.1,0,0-.1-.2-.2-.3v-.4c0-.1.1-.2.3-.3.3-.2.7-.4,1-.6.3-.1.6-.2.9-.3.6-.1,1.1-.2,1.5,0,.4,0,.7.3,1,.6.2.3.4.7.5,1.3.2,1,.3,1.9.5,2.9v.6c-.1.2-.3.3-.5.3h-.6c-.1-.1-.2-.3-.3-.5v-.6h0c0,.3,0,.6-.2.8-.1.2-.3.5-.5.6-.2.2-.5.3-.8.4v-.2Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M410.1,230.5c0,99.4-80.6,180-180,180S50.1,329.9,50.1,230.5,130.7,50.5,230.1,50.5s180,80.6,180,180ZM230.1,95.5c-74.6,0-135,60.4-135,135s60.4,135,135,135,135-60.4,135-135-60.4-135-135-135Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.3,290.5l-16.4,6.5-1.2-2.9,7.1-2.8-3.3-8.4-7.1,2.8-1.2-3,16.4-6.5,1.2,3-6.9,2.7,3.3,8.4,6.9-2.7,1.2,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98.2,304.1c-.4,1.1-1.3,2.1-2.8,2.9l-6.6,3.5-1.4-2.6,1.7-.9c-.7,0-1.4-.1-2-.5s-1.1-.9-1.5-1.6-.6-1.5-.6-2.2,0-1.4.5-2c.3-.6.8-1.1,1.5-1.4.8-.4,1.5-.5,2.2-.4.7.2,1.3.7,2,1.5s1.5,2,2.3,3.6l.3.6.5-.3c.7-.4,1.2-.8,1.3-1.3.2-.5,0-1.1-.3-1.8-.3-.6-.7-1.1-1.2-1.6s-1.1-1-1.8-1.4l1.5-1.8c.7.4,1.4,1,2.1,1.7.7.7,1.3,1.5,1.7,2.2.8,1.5,1,2.8.7,4v-.2ZM89.6,305.8c.7.2,1.5.1,2.3-.3l.5-.2-.2-.4c-.5-1-1-1.7-1.3-2.2-.4-.5-.7-.8-1.1-.9-.3-.1-.7,0-1.1.1-.5.2-.8.6-.9,1.1,0,.5,0,1,.2,1.5.4.7,1,1.2,1.7,1.4h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M107.4,317.1l-13.2,2.1-1.5-2.3,7.4-11,1.8,2.8-5.4,7.6,9.2-1.7,1.7,2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M109.3,330.5l-5.1-6.6c-.8.8-1.3,1.6-1.4,2.3,0,.8.2,1.6.9,2.5.8,1.1,1.9,1.8,3.3,2.1l-1.2,2c-.7-.2-1.4-.5-2.2-1-.7-.5-1.4-1.1-1.9-1.8-1.2-1.6-1.7-3.2-1.5-4.8.2-1.6,1.1-3,2.6-4.2,1-.8,2-1.2,3.1-1.4,1.1-.2,2.1,0,3.1.3,1,.4,1.8,1.1,2.5,2,1,1.3,1.4,2.7,1.1,4.2-.3,1.4-1.2,2.7-2.7,3.9l-.7.5h0ZM107.9,322.2c-.7,0-1.5.1-2.4.7l3.4,4.5c.8-.6,1.2-1.3,1.4-2,0-.7,0-1.4-.6-2-.5-.7-1.1-1-1.9-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M128.1,340.9l-17,6.5-2.2-2.2,5.1-1.9,4.8-11.9,2.3,2.3-3.7,8.5,8.6-3.5,2.2,2.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M123.2,351.9c-.4-1-.5-2-.2-3.1.2-1.1.8-2.1,1.6-3.1.8-1,1.8-1.7,2.8-2.1s2-.5,3.1-.3,2.1.7,3,1.5c1,.8,1.6,1.7,2,2.7s.5,2,.2,3.1c-.2,1.1-.8,2.1-1.6,3.1-.8,1-1.8,1.7-2.8,2.1s-2,.5-3.1.3-2.1-.7-3-1.5c-1-.8-1.6-1.7-2-2.7ZM129.2,353.5c.8-.2,1.7-.7,2.5-1.7s1.3-1.9,1.3-2.8-.3-1.6-1.1-2.3-1.6-.9-2.4-.7c-.9.2-1.7.7-2.5,1.7s-1.3,1.9-1.3,2.8.3,1.6,1.1,2.2c.8.7,1.6.9,2.4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M149.2,357l-7,10-2.5-1.7,1.1-1.5c-.7.3-1.4.5-2.2.4-.7,0-1.4-.3-2.1-.8-2.5-1.7-2.7-3.9-.8-6.7l4.2-6.1,2.6,1.8-4.2,6.1c-.5.7-.7,1.3-.7,1.9s.4,1,1,1.5c.7.5,1.4.7,2.2.5s1.4-.6,2-1.4l3.9-5.6,2.6,1.8v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M153.4,372.9c-.6-.9-.9-1.9-.9-3s.3-2.2.9-3.3c.6-1.1,1.3-2,2.3-2.6.9-.6,1.9-.9,3-1,1.1,0,2.2.3,3.3.8.8.4,1.5.9,2.1,1.5s1,1.3,1.2,1.9l-1.8,1.5c-.3-.6-.6-1.1-1-1.6s-.9-.8-1.4-1.1c-1-.5-1.9-.6-2.7-.3-.8.3-1.6,1-2.1,2.2-.6,1.1-.8,2.1-.5,3,.2.9.8,1.6,1.8,2.1.5.3,1.1.4,1.7.5h1.9l-.2,2.3c-.7.2-1.5.2-2.3,0-.9-.1-1.7-.4-2.5-.8-1.1-.6-2-1.3-2.6-2.2h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.7,371.9c.3,1,.2,2.3-.4,3.9l-2.9,6.9-2.9-1.2,2.8-6.8c.4-.9.5-1.6.3-2.1s-.6-1-1.3-1.2c-.8-.3-1.6-.4-2.3,0s-1.3.9-1.6,1.8l-2.6,6.4-2.9-1.2,6.7-16.3,2.9,1.2-2.7,6.6c.6-.4,1.3-.7,2.1-.7s1.5,0,2.3.4c1.4.6,2.2,1.4,2.5,2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M189.1,381.9l-8-2.5c-.2,1.1-.2,2,.2,2.7s1.1,1.2,2.1,1.5c1.3.4,2.6.3,3.9-.1l.2,2.3c-.7.3-1.5.4-2.4.4s-1.8-.1-2.6-.4c-1.9-.6-3.3-1.6-4-3-.8-1.4-.9-3.1-.3-5,.4-1.2.9-2.2,1.7-3s1.7-1.3,2.7-1.5,2.1-.2,3.2.1c1.6.5,2.7,1.4,3.3,2.7s.6,2.9,0,4.7l-.3.8.3.3ZM183.3,375.9c-.6.4-1.2,1-1.6,1.9l5.4,1.7c.3-1,.3-1.8,0-2.4s-.8-1.1-1.6-1.3c-.8-.2-1.5-.2-2.2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M192.9,387.9c-.8-.7-1.4-1.6-1.6-2.6s-.3-2.2,0-3.4.8-2.3,1.5-3.1c.7-.8,1.6-1.4,2.7-1.7,1.1-.3,2.2-.3,3.4,0,.8.2,1.6.5,2.4,1,.7.4,1.3,1,1.7,1.5l-1.4,2c-.4-.5-.9-.9-1.4-1.3-.5-.3-1-.6-1.6-.7-1.1-.2-2,0-2.7.4-.7.5-1.2,1.4-1.5,2.6s-.2,2.2.3,3c.4.8,1.2,1.3,2.2,1.5.6.1,1.1.1,1.7,0,.6,0,1.2-.3,1.8-.6l.4,2.3c-.6.4-1.4.6-2.2.7-.9,0-1.7,0-2.6-.2-1.3-.3-2.3-.8-3.1-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M211.5,391.8l-4.4-6.2-.8,5.5-3.1-.4,2.4-17.5,3.1.4-1.5,10.7,5.6-4.6,3.8.5-6.2,5.1,5,7.1-3.8-.5h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M228.1,387.4l-8.3-.4c0,1.1.3,2,.9,2.6.6.6,1.4.9,2.5,1,1.3,0,2.6-.3,3.8-1.1l.8,2.2c-.6.4-1.3.8-2.2,1s-1.7.3-2.6.3c-2-.1-3.5-.7-4.6-1.9s-1.6-2.8-1.5-4.7c0-1.2.4-2.3.9-3.3.5-.9,1.3-1.7,2.2-2.1.9-.5,2-.7,3.1-.6,1.7,0,3,.7,3.9,1.8.9,1.1,1.3,2.6,1.2,4.5v.9-.2ZM220.9,383c-.5.5-.9,1.3-1.1,2.2l5.6.3c0-1-.2-1.8-.6-2.3s-1.1-.8-1.9-.9c-.8,0-1.5.2-2,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M242.4,374.8l.8,17.6h-3.1c0,.1,0-1.8,0-1.8-.3.7-.8,1.3-1.5,1.7-.7.4-1.5.6-2.3.7-1,0-2-.2-2.8-.7s-1.5-1.2-2-2.2-.8-2.1-.8-3.3.1-2.4.5-3.4,1-1.7,1.8-2.3c.8-.6,1.7-.8,2.8-.9.9,0,1.7.1,2.4.4s1.2.8,1.6,1.5l-.3-7.2h3.1-.2ZM239.1,389.3c.5-.7.7-1.7.7-3s-.4-2.2-.9-2.9c-.6-.7-1.3-1-2.3-.9-1,0-1.8.4-2.3,1.1s-.8,1.7-.7,2.9c0,1.3.4,2.2,1,2.9.6.7,1.4,1,2.3,1s1.8-.4,2.3-1.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M263,377.2l-4.3,17.7-3.1.6,1.3-5.3-7.1-10.7,3.2-.6,4.9,7.9,2-9.1,3-.5h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M269.3,387.5c-1-.3-1.9-.8-2.7-1.6-.8-.8-1.3-1.8-1.6-3.1s-.4-2.4-.1-3.4c.2-1.1.8-2,1.5-2.7.8-.7,1.8-1.3,3-1.6,1.2-.3,2.3-.4,3.4-.1,1,.3,1.9.8,2.7,1.6.7.8,1.3,1.8,1.6,3s.4,2.4.1,3.5c-.2,1.1-.7,2-1.5,2.7s-1.8,1.3-3,1.6c-1.2.3-2.3.4-3.4.1ZM274,383.5c.3-.8.3-1.8,0-3.1-.3-1.2-.9-2.1-1.5-2.6-.7-.5-1.5-.6-2.5-.4-1,.3-1.6.8-2,1.6-.3.8-.4,1.8,0,3,.3,1.3.9,2.1,1.5,2.6.7.5,1.5.6,2.5.4,1-.3,1.6-.8,2-1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M288.2,369l4.3,11.4-2.9,1.1-.7-1.8c-.1.8-.4,1.4-.9,2s-1.1,1-1.9,1.3c-2.8,1.1-4.8,0-6-3.1l-2.6-6.9,2.9-1.1,2.6,6.9c.3.8.7,1.3,1.2,1.6.5.3,1.1.3,1.8,0,.8-.3,1.4-.8,1.6-1.5.3-.7.3-1.5,0-2.4l-2.4-6.4,2.9-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M299.1,366.5l-1.6.9c-1.8,1.1-2.3,2.5-1.5,4.2l2.8,6-2.8,1.3-5.2-11.1,2.7-1.3.9,1.9c0-1.6.8-2.9,2.5-3.8l.8-.5,1.3,2.3h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M319.9,352.2c1,.3,2,1.2,2.9,2.6l4.1,6.3-2.6,1.7-4-6.2c-.5-.8-1-1.3-1.5-1.4-.5-.2-1,0-1.6.3-.7.5-1.1,1.1-1.2,1.8,0,.7.2,1.5.7,2.4l3.7,5.7-2.6,1.7-4-6.2c-.5-.8-1-1.3-1.5-1.4-.5-.2-1,0-1.6.3-.7.4-1.1,1-1.1,1.8s.2,1.5.7,2.4l3.7,5.7-2.6,1.7-6.7-10.2,2.5-1.7.9,1.4c0-.8,0-1.5.4-2.1s.9-1.2,1.6-1.7c1.5-1,3-1,4.3,0,0-.8,0-1.6.5-2.3s.9-1.3,1.7-1.8c1.2-.8,2.2-1,3.3-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M330.4,343.5c1.2.1,2.3.8,3.4,2.1l4.8,5.7-2.3,1.9-1.2-1.4c.2.7.2,1.4,0,2-.2.7-.7,1.3-1.3,1.8-.6.5-1.3.9-2,1-.7.2-1.4.2-2.1,0s-1.2-.6-1.7-1.1c-.6-.7-.9-1.4-.8-2.1,0-.7.3-1.5,1-2.3.6-.8,1.7-1.8,3-3l.5-.4-.4-.4c-.5-.6-1.1-1-1.6-1s-1.1.2-1.7.7c-.5.4-.9.9-1.3,1.6s-.7,1.3-1,2.1l-2.1-1.1c.2-.8.6-1.6,1.2-2.4s1.2-1.5,1.8-2.1c1.3-1.1,2.6-1.6,3.7-1.5h.1ZM333.9,351.6c0-.8-.2-1.5-.8-2.2l-.3-.4-.3.3c-.9.7-1.5,1.3-1.9,1.8s-.6.9-.7,1.3,0,.7.4,1c.3.4.8.6,1.3.7.5,0,1-.1,1.4-.5.6-.5,1-1.2,1-2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M340.1,336.1l-1.2,1.4c-1.3,1.6-1.3,3.1,0,4.4l4.6,4.7-2.2,2.2-8.5-8.8,2.1-2.1,1.5,1.5c-.6-1.5-.2-3,1.1-4.5l.6-.7,2,1.7v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M347,324.9l8.3,7.3c1.4,1.3,2.2,2.6,2.2,4.1s-.6,2.9-2,4.5c-.7.8-1.5,1.5-2.3,2-.9.6-1.7.9-2.6,1.2l-1.1-2.1c1.7-.5,3.1-1.4,4.1-2.6,1.4-1.6,1.3-3.1-.3-4.6l-1.2-1.1c.3.7.3,1.5.1,2.2s-.6,1.5-1.2,2.2c-.7.8-1.5,1.3-2.4,1.6-.9.3-1.9.3-2.9,0s-1.9-.8-2.8-1.6-1.5-1.7-1.9-2.6c-.4-1-.5-1.9-.3-2.9s.6-1.8,1.3-2.6c.6-.7,1.3-1.2,2-1.4s1.5-.3,2.2-.2l-1.4-1.2,2-2.3h.2ZM350.7,333.4c-.1-.8-.6-1.6-1.5-2.4s-1.7-1.1-2.6-1.2c-.9,0-1.6.4-2.3,1.1-.6.7-.9,1.5-.8,2.4s.6,1.7,1.5,2.4c.8.7,1.7,1.1,2.6,1.1s1.6-.4,2.3-1.1c.7-.8.9-1.6.8-2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M346.1,316.7l2.4,1.9-2.1,2.7-2.4-1.9,2.1-2.7ZM348.6,322.7l1.9-2.5,9.7,7.4-1.9,2.5-9.7-7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M358.7,310c1.1-.1,2.3.3,3.7,1.2l6.3,4.1-1.7,2.6-6.1-4c-.8-.5-1.5-.8-2-.7-.6,0-1,.4-1.5,1-.5.8-.7,1.5-.5,2.3s.7,1.4,1.4,1.9l5.8,3.8-1.7,2.6-10.2-6.8,1.7-2.5,1.5,1c-.3-.7-.5-1.5-.4-2.3,0-.8.4-1.5.9-2.3.8-1.2,1.8-1.9,2.9-2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M371.2,310.4c-.7.7-1.4,1.2-2.1,1.5l-1.5-1.8c1.5-.7,2.6-1.8,3.4-3.3.3-.6.5-1.2.5-1.6s-.2-.8-.6-1c-.3-.2-.6-.2-.9,0s-.7.5-1.1,1l-1.3,1.5c-.8.9-1.5,1.4-2.3,1.6s-1.5.1-2.3-.3c-.7-.4-1.1-.9-1.4-1.5s-.4-1.4-.3-2.2.4-1.7.8-2.5.9-1.4,1.5-2,1.3-1,2-1.3l1.5,1.8c-1.4.7-2.4,1.6-3,2.7-.3.6-.5,1.1-.4,1.6,0,.5.3.8.6,1,.3.2.6.2.9,0,.3-.1.6-.4,1-.8l1.4-1.6c.8-.9,1.6-1.5,2.4-1.7s1.6-.1,2.4.3,1.6,1.4,1.7,2.5-.2,2.4-.9,3.8c-.5,1-1.1,1.8-1.8,2.4h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M372,295.7c-.8-.4-1.5-.8-1.9-1.4-.4-.6-.9-1.3-1.3-2.2-.3-.7-.6-1.2-.9-1.6-.3-.4-.6-.7-1.1-.9s-1-.2-1.5,0-.8.7-1.1,1.3c-.3.7-.5,1.4-.5,2.3s0,1.7.3,2.7h-2.6c-.3-.9-.4-1.9-.3-3s.4-2.2.8-3.2c.4-.9.9-1.7,1.6-2.3.6-.6,1.3-.9,2.1-1.1.8-.1,1.5,0,2.2.3.8.4,1.4.9,1.8,1.5s.8,1.5,1.2,2.5c.4.9.7,1.6,1,2.1s.7.9,1.2,1.2l.6.4-.8,1.7-.9-.4h0ZM374.2,297.5l1.4-3.2,3.1,1.4-1.4,3.2-3.1-1.4Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st13",
    x: 278.3,
    y: 168.4,
    width: 101.7,
    height: 101.7
  })), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 174.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 174.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 174.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 174.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 174.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 174.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 174.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 174.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 174.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 174.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 177.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 177.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 177.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 177.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 177.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 177.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 180.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 180.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 180.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 180.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 180.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 180.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 180.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 180.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 180.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 183.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 183.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 183.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 183.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 183.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 183.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 183.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 186.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 186.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 186.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 186.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 186.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 186.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 186.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 186.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 186.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 190,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 190,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 190,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 190,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 190,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 190,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 190,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 193,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 193,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 193,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 193,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 193,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 193,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 193,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 196.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 196.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 196.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.5,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.7,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.9,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.2,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.6,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 199.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.5,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.7,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.3,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.6,
    y: 202.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.5,
    y: 205.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.7,
    y: 205.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 205.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 205.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 205.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 205.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 205.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.2,
    y: 205.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.3,
    y: 205.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 205.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    y: 205.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.5,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.7,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.9,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.2,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.2,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.3,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.5,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 208.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.7,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.9,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.2,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 211.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.5,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.5,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.7,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.2,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.3,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.5,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.6,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 214.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.9,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.2,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 217.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.5,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.7,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.2,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 220.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.5,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.7,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.9,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.5,
    y: 223.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.5,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.5,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.9,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.2,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.6,
    y: 226.9,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.5,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.5,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.9,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.2,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.5,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 230,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.5,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.5,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.7,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.8,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.9,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.2,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.5,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    y: 233.1,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.5,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.5,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.7,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.9,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.2,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.2,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.3,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.5,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.6,
    y: 236.2,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.5,
    y: 239.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 242.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 242.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 242.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 242.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 242.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 242.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 242.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 242.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.2,
    y: 242.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 242.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.5,
    y: 242.3,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 245.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 245.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 245.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 245.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 245.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 245.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 245.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 245.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 245.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.6,
    y: 245.4,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.2,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.2,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.3,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.5,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.6,
    y: 248.5,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 251.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 251.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 251.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 251.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 251.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 251.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 251.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.2,
    y: 251.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.3,
    y: 251.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.6,
    y: 251.6,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.6,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.2,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.3,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.6,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 254.7,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.2,
    y: 257.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 257.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.3,
    y: 257.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 257.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 257.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.2,
    y: 257.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.3,
    y: 257.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 257.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.5,
    y: 257.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.6,
    y: 257.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.7,
    y: 257.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.1,
    y: 260.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.4,
    y: 260.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.5,
    y: 260.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.8,
    y: 260.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.8,
    y: 260.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.9,
    y: 260.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343,
    y: 260.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.1,
    y: 260.8,
    width: 3.1,
    height: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.8,174.6h-18.3v21.6h21.6v-21.6h-3.3ZM302.8,192.9h-15.1v-15.1h15.1v15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.6,174.6h-18.3v21.6h21.6v-21.6h-3.3ZM370.6,192.9h-15.1v-15.1h15.1v15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.8,242.3h-18.3v21.6h21.6v-21.6h-3.3ZM302.8,260.7h-15.1v-15.1h15.1v15.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 180.7,
    width: 9.2,
    height: 9.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.4,
    y: 180.7,
    width: 9.2,
    height: 9.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 248.5,
    width: 9.2,
    height: 9.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M192.8,142.6c1.3-1.5,5.5-5,12-12.5s12.5-13.3,20.3-12.5c4.8.5,5.3,4.2,5,7,.8-3.9-.4-9.6-2.2-16.8-2.1-8.5-9-11.6-17.7-12.5-4.6-.5-9.2-.2-13.7.6-30.8,5.5-48.7,20.2-55.4,71.5s-.4,1.1-.9,1.5c-27.6,19-2.6,45.1,11.1,45.6-9-9.8-6.8-27.3,6-35.4,12.8-8,27.3-22.6,31.6-30.6,1-1.8,2.4-3.7,4-5.5v-.3h-.1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.4,150.6c-.3,0-.3-3.3.9-8.4.6-2.5,1.6-5.5,3.1-8.7,1.5-3.1,3.5-6.4,5.9-9.6,5-6.3,10.8-10.8,15.2-13.5,4.5-2.7,7.6-3.7,7.7-3.5.1.3-2.7,1.8-6.8,4.8s-9.6,7.5-14.3,13.6c-2.4,3-4.3,6.2-5.9,9.1-1.5,3-2.6,5.8-3.4,8.2-1.6,4.8-2.1,8-2.4,7.9h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.9,158.9c0-.2,1.3-.5,3.5-1.6s5.1-3.2,8.2-6.3c3.2-3.1,6.6-7.1,10.2-11.7s7.5-9.8,11.7-15.2c2.1-2.7,4.3-5.3,6.5-7.6,1.1-1.2,2.2-2.3,3.5-3.4,1.2-1.1,2.4-2,3.8-2.8,5.4-2.9,10.6-4.5,15.1-5.2,2.3-.3,4.3-.4,6.1-.3,1.8,0,3.4.4,4.6.7,2.5.7,3.7,1.5,3.6,1.7,0,0-1.3-.4-3.8-.8-1.2-.2-2.7-.3-4.4-.3s-3.7.2-5.8.6c-4.3.8-9.3,2.6-14.3,5.4-2.4,1.4-4.5,3.6-6.7,5.9-2.1,2.3-4.2,4.9-6.3,7.5-4.2,5.3-8.1,10.5-11.9,15.1-3.8,4.6-7.4,8.6-10.7,11.6-3.4,3-6.5,5-8.9,5.9s-3.9.9-3.9.8h-.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.9,168.2s.2-.3.7-.6c.2-.2.6-.4.9-.6.4-.2.8-.5,1.2-.8,1.9-1.2,4.5-3.1,7.5-5.7,6.1-5.2,13.7-13.3,20.8-23.2.9-1.2,1.7-2.5,2.6-3.7.8-1.2,1.6-2.5,2.4-3.7.8-1.2,1.7-2.4,2.5-3.6.9-1.1,1.8-2.2,2.6-3.2,3.6-4.1,7.7-7,11.4-8.8s7.1-2.5,9.4-2.6c2.3,0,3.6.2,3.5.3,0,.2-1.3,0-3.4.5-2.2.4-5.3,1.3-8.7,3.2-3.4,1.9-7.2,4.8-10.6,8.8-.8,1-1.7,2.1-2.5,3.1-.8,1.1-1.6,2.3-2.4,3.5-.8,1.2-1.6,2.5-2.4,3.7-.9,1.2-1.7,2.5-2.6,3.8-7.3,10.1-15.2,18.2-21.6,23.1-3.2,2.5-6.1,4.2-8.1,5.2-.5.2-1,.5-1.4.6-.4.2-.8.3-1,.4-.6.2-.9.3-.9.2h.1Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.1,199.8c0,0-.6-.6-1.4-1.9-.2-.3-.4-.7-.6-1.1-.2-.4-.4-.9-.6-1.4s-.5-1-.6-1.7c0-.6-.3-1.3-.4-1.9-.5-2.7-.4-6.2.9-9.7.6-1.8,1.6-3.5,2.7-5.1,1.2-1.6,2.5-3.2,4-4.7,3-2.9,6.2-5.2,9.1-7.3,2.9-2.1,5.6-3.8,7.8-5.3,4.5-2.9,7.4-4.5,7.6-4.2.2.3-2.4,2.3-6.7,5.6-2.2,1.6-4.7,3.5-7.5,5.6s-5.9,4.5-8.7,7.2c-1.4,1.4-2.7,2.9-3.8,4.3-1,1.5-2,3-2.6,4.6-1.3,3.1-1.5,6.2-1.3,8.7,0,.6.2,1.2.2,1.8s.3,1.1.4,1.6.2,1,.4,1.4c0,.4.3.8.4,1.2.5,1.4.7,2.2.6,2.3h0Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M104.6,144.8l-5.2,8.1,2.8,4.2-2,3.1-11.8-18.1,1.6-2.5,21.4,3.1-1.9,3-5-.8h.1ZM101.6,144.3l-9-1.5,5.1,7.6,3.9-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M105.5,119.1l15.2,12.6-2.2,2.7-1.7-1.4c.3.8.4,1.6.3,2.5-.2.9-.6,1.7-1.2,2.5-.7.9-1.6,1.5-2.7,1.9-1,.3-2.2.4-3.3,0-1.2-.3-2.3-.9-3.4-1.8s-1.9-1.9-2.4-3-.7-2.1-.5-3.2c0-1.1.6-2.1,1.3-3,.6-.8,1.3-1.3,2.2-1.6s1.6-.4,2.5-.3l-6.2-5.1,2.2-2.7h-.1ZM115.1,132.7c-.2-1-.9-1.9-1.9-2.8-1.1-.9-2.1-1.4-3.1-1.4s-1.8.4-2.5,1.3-1,1.8-.8,2.7c.2,1,.8,1.9,1.9,2.8s2.1,1.4,3.1,1.4,1.8-.4,2.5-1.2c.7-.9,1-1.8.8-2.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M122.4,110.6l5.3,13.9-2.2,2.1-13.8-5.6,2.6-2.6,9.5,4.2-4-9.7,2.5-2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M132.6,103.7c1.3,0,2.6,1,3.8,2.5l5.3,6.4-2.6,2.1-1.3-1.6c.2.8.2,1.5,0,2.3-.3.7-.8,1.4-1.4,2-.7.6-1.5,1-2.3,1.1-.8.2-1.6.2-2.3,0-.7-.2-1.4-.7-1.9-1.3-.6-.8-.9-1.6-.9-2.3s.4-1.6,1.1-2.6c.7-.9,1.9-2,3.5-3.3l.5-.4-.4-.5c-.6-.7-1.2-1.1-1.7-1.2-.6,0-1.2.2-1.9.8-.6.5-1.1,1-1.5,1.7s-.8,1.5-1.1,2.3l-2.3-1.2c.3-.9.7-1.8,1.4-2.7.6-.9,1.3-1.7,2.1-2.3,1.5-1.2,2.9-1.8,4.2-1.6l-.3-.2ZM136.4,112.7c0-.9-.2-1.7-.8-2.4l-.4-.5-.4.3c-1,.8-1.7,1.4-2.2,2-.5.5-.7,1-.8,1.4,0,.4,0,.8.4,1.2.4.5.8.7,1.4.8.6,0,1.1,0,1.6-.5.7-.6,1.1-1.3,1.2-2.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M146.8,93.9c1.2.3,2.3,1.3,3.3,2.9l4.6,7-2.9,1.9-4.5-6.9c-.6-.9-1.2-1.4-1.8-1.6-.6-.2-1.3,0-2,.4-.8.6-1.3,1.3-1.5,2.1-.2.9,0,1.7.6,2.6l4.3,6.5-2.9,1.9-7.5-11.4,2.9-1.9,1.1,1.7c0-.9.2-1.7.6-2.5s1.1-1.4,1.9-2c1.4-.9,2.7-1.2,3.8-.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M163.4,96.3l1.1,2.4c-.5.3-.9.6-1.3.8-1.7.9-3.2,1.2-4.4.9-1.2-.3-2.3-1.3-3.1-2.8l-2.8-5.2-2.3,1.2-1.2-2.3,2.3-1.2-1.9-3.6,3.1-1.7,1.9,3.6,3.2-1.7,1.3,2.3-3.2,1.7,2.8,5.2c.9,1.6,2.1,2,3.5,1.2.4-.2.7-.4,1.1-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M158.3,79.5l12.1-5.2,1.1,2.6-8.9,3.8,2.2,5,8.4-3.6,1.1,2.6-8.4,3.6,2.3,5.3,8.9-3.8,1.1,2.6-12.1,5.2-7.8-18.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M187.2,68.9l5.8,18.9-3.3,1-.7-2.1c-.2.9-.6,1.6-1.2,2.2-.6.6-1.4,1.1-2.3,1.4-1.1.3-2.2.4-3.3,0-1.1-.3-2-.9-2.8-1.8-.8-.9-1.4-2-1.8-3.4-.4-1.4-.5-2.6-.4-3.8.2-1.2.6-2.2,1.3-3s1.6-1.4,2.8-1.8c.9-.3,1.8-.4,2.7-.2s1.6.5,2.2,1.1l-2.4-7.7,3.3-1v.2ZM187.8,85.6c.4-.9.3-2,0-3.4-.4-1.4-1-2.3-1.8-2.9-.8-.5-1.7-.7-2.8-.3-1.1.3-1.8.9-2.2,1.8-.4.9-.3,2,0,3.3.4,1.4,1,2.3,1.9,2.9.8.6,1.8.7,2.8.4,1.1-.3,1.8-.9,2.1-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M206.4,71.1l2.3,12.2c.4,2.1.1,3.8-.8,5.1s-2.6,2.2-4.8,2.6c-1.2.2-2.3.3-3.5.2s-2.2-.3-3.1-.7l.5-2.6c1.9.7,3.7.9,5.5.5,2.4-.5,3.4-1.9,2.9-4.2l-.3-1.8c-.3.8-.7,1.5-1.4,2.1s-1.5.9-2.5,1.1c-1.2.2-2.3,0-3.3-.2-1-.4-1.9-1-2.6-1.9-.7-.9-1.2-2-1.4-3.3-.3-1.3-.2-2.5,0-3.7.3-1.1.9-2,1.7-2.8s1.8-1.2,3-1.4c1-.2,1.9-.2,2.8.1.8.3,1.5.7,2.1,1.4l-.4-2,3.4-.6h0ZM203.8,81.3c.5-.8.6-1.9.4-3.1-.2-1.3-.7-2.2-1.5-2.8s-1.7-.8-2.8-.6-1.9.7-2.4,1.6c-.5.8-.6,1.9-.4,3.1.2,1.2.7,2.1,1.5,2.8.8.6,1.7.8,2.8.6s1.9-.7,2.4-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M223.2,77l-9.3.9c.2,1.3.7,2.2,1.4,2.7.7.6,1.7.8,2.9.7,1.5,0,2.8-.7,4-1.8l1.2,2.3c-.6.6-1.3,1.1-2.3,1.5-.9.4-1.9.7-2.8.7-2.2.2-4-.3-5.5-1.4-1.4-1.1-2.2-2.8-2.4-5-.1-1.4,0-2.7.5-3.8.5-1.1,1.2-2,2.1-2.7,1-.7,2.1-1.1,3.4-1.2,1.9-.2,3.4.3,4.6,1.4,1.2,1.1,1.9,2.7,2.1,4.8v1h.1ZM214.6,73.3c-.5.6-.8,1.5-.8,2.7l6.3-.6c-.1-1.1-.5-2-1.1-2.5s-1.3-.8-2.3-.7c-.9,0-1.7.5-2.2,1.1h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M234.3,63.5h3.6c0,.1-.7,19.9-.7,19.9h-3.6c0,0,.7-19.9.7-19.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M253.6,72.2c.7,1,.9,2.5.7,4.3l-.9,8.3-3.5-.4.9-8.2c.1-1.1,0-1.8-.3-2.4-.3-.5-.9-.8-1.8-.9-1-.1-1.8.1-2.5.7s-1.1,1.4-1.2,2.4l-.9,7.7-3.5-.4,1.5-13.6,3.4.4-.2,2c.5-.7,1.2-1.2,2.1-1.5.8-.3,1.7-.4,2.7-.3,1.6.2,2.8.8,3.5,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M264.8,84.7l-.7,2.5c-.6,0-1.1,0-1.5-.2-1.9-.4-3.2-1.1-3.9-2.2-.7-1.1-.9-2.4-.6-4.2l1.2-5.8-2.6-.5.5-2.6,2.6.5.8-4,3.4.7-.8,4,3.5.7-.5,2.6-3.5-.7-1.2,5.8c-.4,1.8.3,2.9,2,3.2.4,0,.8,0,1.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M279,84.8l-9-2.6c-.2,1.3-.1,2.3.3,3s1.3,1.3,2.4,1.7c1.5.4,2.9.3,4.4-.2l.3,2.6c-.8.3-1.6.5-2.7.5s-2,0-2.9-.4c-2.2-.6-3.7-1.7-4.6-3.3-.9-1.6-1-3.4-.4-5.5.4-1.3,1-2.5,1.8-3.3.8-.9,1.8-1.5,3-1.8,1.1-.3,2.3-.3,3.6,0,1.8.5,3.1,1.5,3.8,3s.8,3.2.2,5.3l-.3.9h0ZM272.3,78.2c-.7.4-1.3,1.1-1.7,2.2l6.1,1.8c.3-1.1.3-2,0-2.7s-1-1.2-1.9-1.5-1.7-.2-2.4.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M286.3,73.1l3.3,1.2-6.8,18.5-3.3-1.2,6.8-18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M293.4,75.9l3.2,1.4-7.7,18.2-3.2-1.4,7.7-18.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M297.8,84.4l3.2,1.5-5.9,12.4-3.2-1.5,5.9-12.4h0ZM303.8,80.2l-1.5,3.1-3.5-1.7,1.5-3.1,3.5,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M316.2,94.3l-6.2,10.8c-1.1,1.9-2.4,3-4,3.3-1.6.4-3.4,0-5.4-1.2s-2-1.3-2.8-2.1c-.8-.8-1.4-1.7-1.8-2.6l2.1-1.6c1,1.7,2.2,3.1,3.8,4,2.1,1.2,3.8.8,4.9-1.3l.9-1.6c-.7.5-1.6.7-2.4.6s-1.8-.3-2.6-.8c-1-.6-1.8-1.4-2.3-2.3-.5-1-.7-2-.7-3.2s.4-2.3,1.1-3.5,1.5-2.1,2.5-2.7c1-.6,2-1,3.1-1s2.2.3,3.2.9c.9.5,1.5,1.1,2,1.9.5.8.7,1.6.7,2.4l1-1.8,3,1.7h-.1ZM307.6,100.3c.9-.3,1.7-1,2.3-2.1.6-1.1.9-2.1.7-3.1-.2-.9-.8-1.7-1.7-2.3-1-.5-1.9-.7-2.8-.4s-1.7,1-2.3,2.1c-.6,1.1-.8,2.1-.7,3.1.2,1,.7,1.7,1.7,2.3s1.9.7,2.8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M325.2,109.8l-7.6-5.5c-.7,1.1-.9,2.1-.7,3,.2.9.7,1.7,1.7,2.4,1.2.9,2.6,1.3,4.2,1.2l-.6,2.5c-.8,0-1.7,0-2.7-.4s-1.8-.7-2.6-1.3c-1.8-1.3-2.9-2.9-3.2-4.7-.3-1.8.2-3.6,1.5-5.4.8-1.1,1.8-2,2.9-2.5s2.2-.8,3.4-.7c1.2,0,2.3.5,3.3,1.3,1.5,1.1,2.4,2.5,2.6,4.1s-.4,3.3-1.6,5l-.6.8v.2ZM321.1,101.3c-.8.2-1.6.6-2.4,1.5l5.1,3.7c.6-.9.9-1.8.8-2.6,0-.8-.5-1.4-1.3-2s-1.5-.7-2.4-.6h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M340.3,114.5c0,1.2-.7,2.6-1.9,4l-5.6,6.3-2.6-2.3,5.4-6.1c.7-.8,1.1-1.5,1.1-2.1s-.3-1.2-.9-1.8c-.8-.7-1.6-1-2.4-.9-.9,0-1.7.5-2.4,1.3l-5.2,5.8-2.6-2.3,9.1-10.2,2.6,2.3-1.4,1.5c.9-.3,1.7-.3,2.6,0,.9.2,1.7.6,2.4,1.3,1.2,1.1,1.8,2.3,1.8,3.5v-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M337,128.2c-.3-1.2-.2-2.3.2-3.5s1.1-2.2,2.2-3.1c1-1,2.2-1.6,3.4-1.9,1.2-.3,2.4-.3,3.6,0s2.2,1.1,3.2,2.1c.7.7,1.2,1.5,1.6,2.4s.6,1.7.6,2.5l-2.5.9c0-.7-.2-1.4-.5-2.1-.3-.6-.6-1.2-1-1.7-.8-.9-1.7-1.3-2.8-1.3s-2,.5-3.1,1.5c-1,1-1.6,1.9-1.7,2.9,0,1,.3,2,1.1,2.8.4.5,1,.9,1.6,1.2.6.3,1.3.5,2,.6l-1.1,2.4c-.8,0-1.6-.3-2.5-.8s-1.6-1.1-2.3-1.8c-1-1.1-1.6-2.2-1.9-3.3h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M355.9,142.1l-5.7-7.4c-.9.9-1.5,1.7-1.5,2.6s.2,1.8,1,2.8c.9,1.2,2.1,2,3.7,2.4l-1.3,2.3c-.8-.2-1.6-.6-2.5-1.1-.8-.6-1.6-1.2-2.1-2-1.4-1.8-1.9-3.6-1.7-5.4.2-1.8,1.2-3.4,2.9-4.7,1.1-.9,2.3-1.4,3.5-1.6s2.3,0,3.4.3,2,1.2,2.8,2.2c1.1,1.5,1.6,3,1.3,4.7s-1.3,3.1-3,4.4l-.8.6h0ZM354.4,132.9c-.8,0-1.7.2-2.7.7l3.9,5c.9-.7,1.4-1.5,1.5-2.2.1-.8,0-1.5-.6-2.3-.6-.7-1.3-1.2-2.1-1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M369,135.4l3.1,5-1.3.8-1.1-1.7-4.6,2.8-1-1.6,4.6-2.8-1.1-1.7,1.3-.8h.1ZM376.3,147.1l-5.8,3.6-.9-1.4,3.1-1.9-2.7.2-.6-1,1.3-2.3-3,1.9-.9-1.4,5.8-3.6.8,1.2-2.2,3.8,4.4-.3.7,1.2h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClairaAdvAvatar);
export default __webpack_public_path__ + "static/media/ClairaAdvAvatar.1051f05e399f3903113eb0a59a69c5cb.svg";
export { ForwardRef as ReactComponent };